{
    "NAME": "Elenco dispositiviLingua",
    "DeviceList_Column_DeviceNumber": "Dispositivo",
    "DeviceList_Column_DeviceNumberInternal": "Estensione",
    "DeviceList_Column_Description": "Descrizione",
    "DeviceList_Column_Partition": "Partizione",
    "DeviceList_Column_DeviceType": "Tipo di dispositivo",
    "DeviceList_Column_IDOnTelSys": "Account delle risorse",
    "DeviceList_Column_QueueStatus": "Stato della coda",
    "DeviceList_Column_Users": "Utenti",
    "DeviceList_Filter_DeviceType": "Tipo di dispositivo",
    "DeviceList_Filter_Partition": "Partizione",
    "DeviceList_Add_Disabled_SelectTelephonyServer": "Seleziona un server di telefonia per aggiungere un dispositivo",
    "DeviceList_Users_MoreUsers": "[{} altri utenti]",
    "DeviceList_Value_None": "Nessuno",
    "DeviceList_Value_All": "Tutto"
}